export default {"src":"/_next/static/media/Discord.22260f29.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};